// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4d6c2b28","455":"036c3aa1","977":"f435c7df"}[chunkId] + ".chunk.js";
};